import { render, staticRenderFns } from "./CommentRequest.vue?vue&type=template&id=27cc5149&scoped=true&"
import script from "./CommentRequest.vue?vue&type=script&lang=js&"
export * from "./CommentRequest.vue?vue&type=script&lang=js&"
import style0 from "./CommentRequest.vue?vue&type=style&index=0&id=27cc5149&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc5149",
  null
  
)

export default component.exports